import { render, staticRenderFns } from "./LkFooter.vue?vue&type=template&id=c0f9d9e4&"
import script from "./LkFooter.vue?vue&type=script&lang=js&"
export * from "./LkFooter.vue?vue&type=script&lang=js&"
import style0 from "./LkFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports